import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "chevron"]
  static values = { expanded: Boolean }

  connect() {
    // Auto-expand if child link is active
    if (this.hasMenuTarget) {
      const hasActiveLink = this.menuTarget.querySelector('.sidebar-link-active')
      if (hasActiveLink) {
        this.expandedValue = true
        this.updateUI()
      }
    }
  }

  toggle(event) {
    event.preventDefault()
    this.expandedValue = !this.expandedValue
    this.updateUI()
  }

  updateUI() {
    if (this.hasMenuTarget) {
      if (this.expandedValue) {
        this.menuTarget.classList.remove('hidden')
      } else {
        this.menuTarget.classList.add('hidden')
      }
    }

    if (this.hasChevronTarget) {
      if (this.expandedValue) {
        this.chevronTarget.classList.add('rotate-180')
      } else {
        this.chevronTarget.classList.remove('rotate-180')
      }
    }
  }
}
